import { render, staticRenderFns } from "./GetDocument.vue?vue&type=template&id=a5ded408&"
import script from "./GetDocument.vue?vue&type=script&lang=js&"
export * from "./GetDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports